"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.extractDomain = exports.shouldOpenSecurityWarningModal = exports.extractHostnameFromLink = exports.openLinkInNewTab = exports.shouldBeRenderedAsLink = exports.hasSafeProtocol = exports.safeProtocols = exports.hasValidTLD = exports.isDomainWithUrlParams = exports.isDomain = exports.isValidLink = void 0;
var psl_1 = __importDefault(require("psl"));
var constants_1 = require("../../constants");
var isValidLink = function (link) {
    return link.match(constants_1.STARTING_WITH_VALID_PROTOCOL) && link.match(constants_1.NOT_STARTING_WITH_FTP);
};
exports.isValidLink = isValidLink;
// .match is working with multiple matches return type is an array
var isDomain = function (domain) {
    return constants_1.IS_DOMAIN.test(domain);
};
exports.isDomain = isDomain;
var isDomainWithUrlParams = function (link) {
    return link.match(constants_1.IS_DOMAIN_WITH_URL_PARAMS);
};
exports.isDomainWithUrlParams = isDomainWithUrlParams;
var hasValidTLD = function (link) {
    var hostname = (0, exports.extractHostnameFromLink)(link);
    return psl_1.default.isValid(hostname);
};
exports.hasValidTLD = hasValidTLD;
// linkify doesn't support tel: and sms: protocols for the moment
exports.safeProtocols = ['mailto:'];
var hasSafeProtocol = function (link) {
    try {
        var url = new URL(link);
        return exports.safeProtocols.includes(url.protocol);
    }
    catch (e) {
        return false;
    }
};
exports.hasSafeProtocol = hasSafeProtocol;
var shouldBeRenderedAsLink = function (link) {
    if ((0, exports.hasSafeProtocol)(link)) {
        return true;
    }
    return ((0, exports.isValidLink)(link) || (0, exports.isDomain)(link)) && (0, exports.hasValidTLD)(link);
};
exports.shouldBeRenderedAsLink = shouldBeRenderedAsLink;
var openLinkInNewTab = function (link) {
    if ((0, exports.isDomain)(link)) {
        window.open("http://".concat(link));
    }
    window.open(link);
};
exports.openLinkInNewTab = openLinkInNewTab;
// this is an alternative for new URL(validUrl).hostname because it fails for many cases
// ftp.websitename.com  websitename.com  websitename.com example.com facebook.github.io youtube.com  www.食狮.公司.cn  b.c.kobe.jp  a.d.kyoto.or.jp
var extractHostnameFromLink = function (link) {
    var _a, _b, _c, _d;
    var hostname;
    // find & remove protocol (http, ftp, etc.) and get hostname
    if (link.indexOf('//') > -1) {
        hostname = (_a = link.split('/')) === null || _a === void 0 ? void 0 : _a[2];
    }
    else {
        hostname = (_b = link.split('/')) === null || _b === void 0 ? void 0 : _b[0];
    }
    // find & remove port number
    hostname = (_c = hostname.split(':')) === null || _c === void 0 ? void 0 : _c[0];
    // find & remove "?"
    hostname = (_d = hostname.split('?')) === null || _d === void 0 ? void 0 : _d[0];
    return hostname;
};
exports.extractHostnameFromLink = extractHostnameFromLink;
var shouldOpenSecurityWarningModal = function (link, trustedDomains) {
    if ((0, exports.hasSafeProtocol)(link)) {
        return false;
    }
    var hostname = (0, exports.extractHostnameFromLink)(link);
    var parsedHostname = psl_1.default.parse(hostname);
    if (parsedHostname.error || !parsedHostname.domain) {
        return true;
    }
    var domain = parsedHostname.domain;
    var isTrusted = trustedDomains.includes(domain);
    if (isTrusted) {
        return false;
    }
    return true;
};
exports.shouldOpenSecurityWarningModal = shouldOpenSecurityWarningModal;
var extractDomain = function (link) {
    var hostname = (0, exports.extractHostnameFromLink)(link);
    var parsedHostname = psl_1.default.parse(hostname);
    if (parsedHostname.error || !parsedHostname.domain) {
        return '';
    }
    return parsedHostname.domain;
};
exports.extractDomain = extractDomain;
